module.exports = __webpack_public_path__ + "img/schnittkante_rot_candy.e7ace5d0.jpg";